import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section className="bg-brand-dark px-4 py-20" data-id="element-78" data-mp="4vs1604r2hrx">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-79" data-mp="9umi0wj5pw9e">
        <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full bg-brand-alt shadow-sm" data-id="element-80" data-mp="9t1lx2h7259f">
          <ShieldCheckIcon className="h-8 w-8 text-brand-teal" aria-hidden="true" data-id="element-81" data-mp="er35doij86lf" />
        </div>
        <h2 className="text-2xl font-black tracking-wide text-brand-blue md:text-3xl" data-id="element-82" data-mp="jqg0ewjk4jz3">
          💯 Get Your Money Back or Keep It.
        </h2>
        <p className="mt-6 leading-relaxed text-brand-gray" data-id="element-83" data-mp="skkppbj1lnci">
          Spanish Ready is backed by a 30-day, no-questions-asked money-back
          guarantee. If it isn&apos;t right for your classroom, email us for a
          full refund — and you can keep every bonus.
        </p>
      </Reveal>
    </section>;
}